module.exports = __webpack_public_path__ + "static/img/lease.f57c4c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lease.png
// module id = 978
// module chunks = 1